import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("pre", {
    ref: "pre",
    class: _normalizeClass(`${_ctx.languageClass} pre`)
  }, [
    _createElementVNode("code", {
      class: _normalizeClass(`${_ctx.languageClass} code`),
      innerHTML: _ctx.html
    }, null, 10, _hoisted_1)
  ], 2))
}